"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
require("./baseSwitch.scss");
const styled_components_1 = __importDefault(require("styled-components"));
const react_svg_1 = require("react-svg");
const StyledSwitch = styled_components_1.default.div `
  background: ${(props) => `${props.switchBackgroundColor}`} !important;

  .cont .switch-text {
    color: ${(props) => props.inactiveLabelColor} !important;
  }

  .active {
    background: ${(props) => props.primaryColor} !important;

    .switch-text {
      color: ${(props) => props.activeLabelColor} !important;
    }
  }

  .customizable-icon .injected-svg {
    fill: ${(props) => props.inactiveIconColor} !important;
    stroke: none !important;
  }

  .active .customizable-icon .injected-svg {
    fill: ${(props) => props.activeIconColor} !important;
    stroke: none !important;
  }
`;
function BaseSwitch(props) {
    var _a, _b;
    return (react_1.default.createElement(StyledSwitch, { primaryColor: props.primaryColor, activeIconColor: (_a = props.activeIconColor) !== null && _a !== void 0 ? _a : "#F4F8FF", inactiveIconColor: (_b = props.inactiveIconColor) !== null && _b !== void 0 ? _b : "#F4F8FF", switchBackgroundColor: props.switchBackgroundColor, activeLabelColor: props.activeLabelColor, inactiveLabelColor: props.inactiveLabelColor, className: `base-switch ${props.fullSizeOnWeb ? "full-width-switch" : ""}`, style: props.styles, onClick: () => props.setValue(props.value === props.options[0].value
            ? props.options[1].value
            : props.options[0].value) },
        react_1.default.createElement("div", { className: `cont ${props.value === props.options[0].value ? "active" : ""}` },
            react_1.default.createElement(react_svg_1.ReactSVG, { src: props.options[0].icon, className: "cred-img customizable-icon", wrapper: "svg", afterInjection: (svg) => {
                    svg.setAttribute("height", "14px");
                    svg.setAttribute("width", "22px");
                    svg.style.width = "22px";
                    svg.style.height = "14px";
                }, width: 22, height: 14 }),
            (props.isMobile || props.fullSizeOnWeb) && (react_1.default.createElement("span", { className: "switch-text" }, props.options[0].text))),
        react_1.default.createElement("div", { className: `cont ${props.value === props.options[1].value ? "active" : ""}` },
            react_1.default.createElement(react_svg_1.ReactSVG, { src: props.options[1].icon, className: "cred-img customizable-icon", wrapper: "svg", afterInjection: (svg) => {
                    svg.setAttribute("height", "20px");
                    svg.setAttribute("width", "22px");
                    svg.style.width = "22px";
                    svg.style.height = "20px";
                }, width: 22, height: 20 }),
            (props.isMobile || props.fullSizeOnWeb) && (react_1.default.createElement("span", { className: "switch-text" }, props.options[1].text)))));
}
exports.default = BaseSwitch;
